import { DossierDetailsContent, DossierDetailsHeader, DossierDetailsPanel } from "@/app/pages/dossier/dossier-details-panel.tsx";
import { Vestiging } from "@/entities/vestiging";
import { Empty, EmptyDescription, EmptyHeader, EmptyImage, EmptyTitle } from "@/shared/components/ui";
import { FaciliteitenDetailsForStation } from "./faciliteiten-details-for-station";

interface FaciliteitenDetailsReadOnlyProps {
    vestigingen: Vestiging[];
}

export function FaciliteitenDetailsReadOnly({ vestigingen }: Readonly<FaciliteitenDetailsReadOnlyProps>) {
    if (vestigingen.length === 0) {
        return (
            <DossierDetailsPanel>
                <DossierDetailsHeader section="Faciliteiten" showBackButton showBerichtBalk />
                <DossierDetailsContent className="space-y-6">
                    <Empty>
                        <EmptyHeader>
                            <EmptyImage />
                            <EmptyTitle>Geen faciliteiten beschikbaar</EmptyTitle>
                            <EmptyDescription>Er zijn geen faciliteiten aangevraagd voor dit dossier.</EmptyDescription>
                        </EmptyHeader>
                    </Empty>
                </DossierDetailsContent>
            </DossierDetailsPanel>
        );
    }

    const vestigingenByStation = Vestiging.groupByStation(vestigingen);

    return (
        <DossierDetailsPanel>
            <DossierDetailsHeader section="Faciliteiten" showBackButton showBerichtBalk />
            <DossierDetailsContent className="space-y-6">
                <div className="space-y-6">
                    {Object.entries(vestigingenByStation).map(([stationCode, vestigingen]) => {
                        return <FaciliteitenDetailsForStation key={stationCode} stationCode={stationCode} vestigingen={vestigingen} />;
                    })}
                </div>
            </DossierDetailsContent>
        </DossierDetailsPanel>
    );
}
